<template>
  <section class="section services">
    <h2 class="section-title">我们的服务</h2>
    <div class="services-grid">
      <div class="card service-card" v-for="(service, index) in services" :key="index">
        <div class="icon-wrapper" :style="{ background: service.iconBg }">
          <span class="icon">{{ service.icon }}</span>
        </div>
        <h3 class="service-title">{{ service.title }}</h3>
        <p class="service-desc">{{ service.desc }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServicesSection',
  data() {
    return {
      services: [
        {
          icon: '💻',
          iconBg: 'rgba(79, 70, 229, 0.1)',
          title: 'Web 定制开发',
          desc: '基于最新前端架构，打造高性能、响应式的企业级网站与 Web 应用系统。'
        },
        {
          icon: '📱',
          iconBg: 'rgba(124, 58, 237, 0.1)',
          title: '小程序开发',
          desc: '微信/支付宝/抖音等多端小程序定制，无缝对接业务，提供极致流畅体验。'
        },
        {
          icon: '🎨',
          iconBg: 'rgba(236, 72, 153, 0.1)',
          title: 'UI/UX 设计',
          desc: '以用户为中心的设计理念，提供符合品牌调性的视觉交互设计与高保真原型。'
        },
        {
          icon: '⚙️',
          iconBg: 'rgba(16, 185, 129, 0.1)',
          title: '系统架构咨询',
          desc: '全栈技术支持与架构优化方案，解决高并发与数据安全难题，为业务护航。'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 30px;
}

.service-card {
  text-align: center;
  padding: 40px 30px;
  
  &:hover {
    .icon-wrapper {
      transform: scale(1.1);
    }
  }
}

.icon-wrapper {
  width: 70px;
  height: 70px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  font-size: 32px;
  transition: transform var(--transition-speed) ease;
}

.service-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  color: var(--text-primary);
}

.service-desc {
  font-size: 15px;
  color: var(--text-secondary);
  line-height: 1.6;
}
</style>
